import request from '@/utils/request'

// 保存、提交
export const contractAdd = (data) => {
  return request.post('/api/agent/contract/add', data)
}

// 标段列表
export const getBidSectionList = (params) => {
  return request.get('/api/agent/contract/bidSectionList?projectCode='+params.projectCode)
}

// 删除
export const contractDelete = (data) => {
  return request.post('/api/agent/contract/delete?contractCode='+data.contractCode)
}

// 详情
export const contractDetail = (params) => {
  return request.get('/api/agent/contract/detail', params )
}

// 获取标段其他信息
export const contractInit = (params) => {
  return request.get('/api/agent/contract/init',  params )
}

// 列表
export const contractList = (params) => {
  return request.get('/api/agent/contract/list',  params )
}
